// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itemHeader_YJJfA {
  padding: 8px;
  background-color: var( --color-brand100 );
  height: 76px;
}

.itemBody_sbe7L {
  padding : 16px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/enum/EnumItemScreen.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".itemHeader {\n  padding: 8px;\n  background-color: var( --color-brand100 );\n  height: 76px;\n}\n\n.itemBody {\n  padding : 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemHeader": `itemHeader_YJJfA`,
	"itemBody": `itemBody_sbe7L`
};
export default ___CSS_LOADER_EXPORT___;
